import { createModule } from '@Actions/utils';
import { SERVICE_ENDPOINT } from '@Apis/constants';

const CreatePDIRule = createModule({
    base: 'CREATE_PDI_RULE',
    apiDetails: { ...SERVICE_ENDPOINT.PRE_DISPATCH_INSPECTION_RULE, method: 'post' },
    errors: { defaultError: true, customError: '' },
    enableNotification: true,
    customNotificationSuccessMessage: 'PDI rule created successfully',
});

const UpdatePDIRule = createModule({
    base: 'UPDATE_PDI_RULE',
    apiDetails: { ...SERVICE_ENDPOINT.PRE_DISPATCH_INSPECTION_RULE, method: 'put' },
    errors: { defaultError: true, customError: '' },
    enableNotification: true,
    customNotificationSuccessMessage: 'PDI rule updated successfully',
});

const GetPDIRule = createModule({
    base: 'GET_PDI_RULE',
    apiDetails: { ...SERVICE_ENDPOINT.PRE_DISPATCH_INSPECTION_RULE, method: 'get' },
    errors: { defaultError: true, customError: '' },
});
const GetPDIRuleById = createModule({
    base: 'GET_PDI_RULE_BY_ID',
    apiDetails: SERVICE_ENDPOINT.PRE_DISPATCH_INSPECTION_RULE_BY_ID({}),
    errors: { defaultError: true, customError: '' },
});

const DeletePDIRule = createModule({
    base: 'DELETE_PDI_RULE',
    apiDetails: { ...SERVICE_ENDPOINT.PRE_DISPATCH_INSPECTION_RULE, method: 'delete' },
    errors: { defaultError: true, customError: '' },
    enableNotification: true,
    customNotificationSuccessMessage: 'PDI rule deleted successfully',
});

export {
    CreatePDIRule,
    UpdatePDIRule,
    GetPDIRule,
    GetPDIRuleById,
    DeletePDIRule,
};
